import RxQuery from 'utils/api/rxQuery/rxQuery';
import endpoints from 'utils/api/endpoints';
import { IGetProductsByParentCategory } from '../endpointsGenerators/eshopApi/products/getProductsByParentCategory';

const eshopApi = () => new RxQuery('eshopApi');

export const getProductsByParentCategory = (request: IGetProductsByParentCategory) => {
	return eshopApi()
		.setEndpoint(endpoints.eshopApi.products.getProductsByParentCategory.getProductsByParentCategory(request))
		.setType('productsByParentCategory')
		.setInvalidateKey('getProductsByParentCategory')
		.disableCache();
};

export const getByProductId = ({ productId, itemType }: any): RxQuery => {
	return eshopApi()
		.setEndpoint(endpoints.eshopApi.products.getProductById.getProductById({ productId, itemType }))
		.setType('productById');
};

export const getCatEntry = ({ catEntryId }: { catEntryId: string }): RxQuery => {
	return eshopApi()
		.setEndpoint(endpoints.eshopApi.products.getCatEntry.getCatEntry({ catEntryId }))
		.setType('priceByCatEntry')
		.disableCache();
};

export const getPurchaseDeviceHistory = (pageNumber: number, pageSize: number) => {
	return eshopApi()
		.setEndpoint(
			endpoints.eshopApi.products.getPurchaseDeviceHistory.getPurchaseDeviceHistory(pageNumber, pageSize)
		)
		.setType('purchaseDeviceHistory')
		.withErrorHandling();
};

export const getOrderTracking = ({ orderId }: { orderId: string }): RxQuery => {
	return eshopApi()
		.setEndpoint(endpoints.eshopApi.products.getOrderTracking.getOrderTracking({ orderId }))
		.setCacheTime(5000)
		.setType('tracking');
};
